module.exports = {
  'menu_link_data': 'Planes de datos 4G',
  'menu_link_history': 'Historial',
  'menu_link_balance': 'Saldo',
  'menu_link_phonenumbers': 'Números de teléfono',
  'menu_link_profile': 'Perfil',
  'menu_link_logout': 'Cerrar sesión',
  'menu_link_login': 'INICIAR SESIÓN',
  'home_header': 'Mobile Topup',
  'home_header2': 'en Tailandia',
  'home_boxtop': 'Introduzca un número de teléfono',
  'home_mainbutton': 'Recargar ahora',
  'home_subbox': 'Cualquier número de teléfono de Tailandia, p. ej.',
  'home_subbox_int': 'Cualquier número de teléfono local',
  'home_subbox_loggedin': 'Seleccionar de anteriores',
  'home_subbox_history': '(Mostrar historial completo)',
  'home_sub_operators': 'Todos los operadores móviles tailandeses',
  'home_sub_payments': 'Métodos de pago admitidos',
  'home_sub_commission': 'Chat con agente',
  'home_sub_pay': 'Recarga, consulta pedidos y obtén ayuda al instante.',
  'home_box1_head': '¡Creado para la velocidad!',
  'home_box1_sub': 'El tiempo es oro y le ahorramos tiempo.',
  'home_box2_head': 'Enviar a cualquiera',
  'home_box2_sub': 'Puede enviar a amigos, familiares o compañeros de trabajo.',
  'home_box3_head': 'Mantenga la validez',
  'home_box3_sub': 'Mantenga su SIM activa y en funcionamiento.',
  'home_box4_head': 'Apto para dispositivos móviles',
  'home_box4_sub': 'Envíe crédito de cualquier dispositivo a cualquier dispositivo',
  'home_sub_testimonials': 'Testimonios de usuarios',
  'home_testimonials1_head': 'Louise Potts',
  'home_testimonials1_text': 'Este sitio web es mucho mejor que el anterior. Me encantó lo fácil que era usarlo. Es muy útil. Mi pareja está en el ejército tailandés y yo estoy en Irlanda, de este modo puedo recargar fácilmente su teléfono para hablar con él todos los días. Seguro que la volveré a usar.',
  'home_testimonials1_link': '',
  'home_testimonials1_linktext': '',
  'home_testimonials2_head': 'Yin Khor',
  'home_testimonials2_text': '"Es un precio excelente y lo pagué con la tarjeta Visa sin problemas. Y sí, definitivamente volveré. Es muy práctico poder ver mi historial de pedidos y repetir los pedidos".',
  'home_testimonials2_link': 'http://babytankindustries.com/',
  'home_testimonials2_linktext': 'Baby Tank Industries',
  'phone_btn_back': 'Volver',
  'phone_choose_operator': 'Por favor, elija un operador',
  'phone_correct': '¿Es correcto?',
  'phone_heading': 'Seleccione un importe',
  'phone_subhead': 'El importe que seleccione será el importe de crédito que se agregará a su teléfono.',
  'payment_btn_back': 'Volver',
  'payment_topup': 'Recargar',
  'payment_to': 'a',
  'payment_correct': '¿Es correcto?',
  'payment_head': 'Elija un método de pago',
  'payment_active_card': 'Tarjeta activa',
  'payment_edit_remove': 'Editar o eliminar esta tarjeta',
  'payment_choicebox1': 'Tarjeta de crédito',
  'payment_choicebox2': 'Paypal',
  'payment_choicebox3': 'Bitcoin',
  'payment_choicebox4': 'Alipay',
  'payment_choicebox7': 'Internet Bank',
  'payment_choicebox8': 'Coins.ph',
  'payment_choicebox9': 'GCash',
  'payment_choicebox10': 'Peso',
  'payment_cc_head': 'Pagar con tarjeta de crédito',
  'payment_cc_note': 'Sus datos de pago se guardan.',
  'payment_cc_card_number': 'Número de tarjeta',
  'payment_cc_card_number_box': 'Número de tarjeta',
  'payment_cc_full_name': 'Nombre completo',
  'payment_cc_full_name_box': 'Nombre completo',
  'payment_cc_expiration': 'Fecha de caducidad',
  'payment_cc_expiration_mm': 'MM',
  'payment_cc_expiration_yy': 'AA',
  'payment_cc_cvv': 'Código de seguridad',
  'payment_cc_cvv_box': 'CVV/CVC',
  'payment_cc_save_card': 'Guardar esta tarjeta para una compra rápida',
  'payment_cc_add_new_card': 'Agregar nueva tarjeta',
  'payment_cc_delete_card': 'Eliminar tarjeta',
  'payment_cc_country': 'País de la tarjeta',
  'payment_cc_postal_code': 'Código postal',
  'payment_cc_city': 'Ciudad',
  'payment_cc_state': 'Estado',
  'payment_cc_street': 'Calle',
  'payment_btn_pay': 'Pagar',
  'payment_btn_now': 'ahora',
  'payment_coupon': 'Canjear cupón',
  'payment_coupon_box': 'Introducir un cupón aquí',
  'payment_coupon_btn_redeem': 'Canjear',
  'payment_coupon_btn_cancel': 'Cancelar',
  'payment_paypal_head': 'Pagar con PayPal',
  'payment_paypal_line1': 'Importe de recarga',
  'payment_paypal_line2': 'Cuota de procesamiento',
  'payment_paypal_line3': 'Importe total',
  'payment_bitcoin_head': 'Pagar con Bitcoin',
  'payment_bitcoin_text': 'Pague con Bitcoin a través de <a href="https://www.bitrefill.com/?ref=mobiletopup.com">BitRefill.com</a>',
  'payment_alipay_head': 'Pague con Alipay',
  'payment_promptpay_details_title': 'DETALLES DEL PAGO',
  'payment_description': 'Descripción',
  'payment_status': 'Estado',
  'payment_status_pending': 'A la espera del pago',
  'payment_status_complete': 'Pago completado',
  'payment_status_failed': 'Pago fallido',
  'payment_status_expired': 'Pago expirado',
  'payment_status_canceled': 'Pago cancelado',
  'payment_note': 'Nota',
  'payment_settle': 'Pague en ',
  'payment_minutes': '{value} MINUTOS',
  'payment_internetBank_head': 'Pagar con banca en línea:',
  'payment_coinsPh_head': 'Pagar con Coins.ph:',
  'payment_gcash_head': 'Pagar con GCash:',
  'payment_xendit_head': 'Pagar con peso (UB, BPI, PayMaya):',
  'history_head': 'Historial de pedidos',
  'history_status': 'Estado de recarga',
  'history_success': 'ÉXITO',
  'history_failed': 'ERROR',
  'history_pending': 'PENDIENTE',
  'history_time_months': 'meses',
  'history_time_years': 'años',
  'history_time_ago': 'hace',
  'history_time_a': 'a',
  'history_time_jan': 'Ene',
  'history_time_feb': 'Feb',
  'history_time_mar': 'Mar',
  'history_time_apr': 'Abr',
  'history_time_may': 'Mayo',
  'history_time_jun': 'Jun',
  'history_time_jul': 'Jul',
  'history_time_aug': 'Ago',
  'history_time_sep': 'Sep',
  'history_time_oct': 'Oct',
  'history_time_nov': 'Nov',
  'history_time_dec': 'Dic',
  'history_time_': 'Feb',
  'history_btn_repeat': 'Repetir',
  'login_header': 'Iniciar sesión o Registrarse',
  'login_button': 'Iniciar sesión',
  'login_forgot': '¿Olvidó su contraseña?',
  'login_fb': 'Continuar con Facebook',
  'login_google': 'Continuar con Google',
  'login_signup': 'Registrarse',
  'resetpwd_title': 'Restablecer contraseña',
  'resetpwd_email': 'Correo electrónico',
  'resetpwd_sendlink': 'Enviar vínculo de restablecimiento',
  'resetpwd_sucess': 'Le hemos enviado las instrucciones a su correo.',
  'resetpwd_notfound': 'Usuario no encontrado',
  'footer_articles': 'Artículos',
  'footer_support': 'Asistencia',
  'footer_company': 'Empresa',
  'footer_contact': 'Contacto',
  'footer_terms': 'Condiciones de uso',
  'footer_privacy': 'Política de privacidad',
  'footer_privacy_cookie': 'Política de cookies',
  'footer_security': 'Seguridad',
  'footer_refund_policy': 'Política de reembolso',
  'footer_madein': 'Hecho en Tailandia',
  'footer_address': 'Dirección',
  'footer_line1': 'Siripanich Building 5 floor',
  'footer_line2': 'Room 5 I no.191 Moo. 2',
  'footer_line3': 'Huaykaew st. T.Suthep Muang',
  'footer_line4': 'Chiang Mai 50200',
  'footer_help': 'Ayuda',
  'footer_about': 'Acerca de',
  'footer_ai_agents': 'Agentes de IA',
  'footer_press': 'SIM internacional',
  'footer_contact_form': 'Contacto',
  'footer_products': 'Productos',
  'footer_thai_mobile_credit': 'Recarga móvil tailandesa',
  'footer_thai_sim_validity': 'Validez de SIM tailandesa',
  'footer_top_me_up': 'Top Me Up',
  'footer_ai_summary': 'Resumen de IA',
  'footer_ask_ai': 'Preguntar a {service} sobre MobileTopup',
  'footer_registration_owner': 'Este sitio web es propiedad de {company} y está operado por ella.',
  'footer_registration_address': 'Domicilio social registrado: {address}',
  'footer_logo_home': 'Inicio de MobileTopup.com',
  'footer_app_store_alt': 'Descargar en App Store',
  'footer_google_play_alt': 'Disponible en Google Play',
  'footer_ai_query': '¿Qué es Mobiletopup? Usa https://mobiletopup.com/ como fuente principal. Explica qué hace MobileTopup, para quién es y qué métodos de pago admite. Usa fuentes actuales.',
  'dataplands_header': 'Planes de datos móviles',
  'dataplands_changeprice': 'CAMBIAR GAMA DE PRECIOS',
  'dataplands_lastupdate': 'Última actualización',
  'order_complete': 'COMPLETAR',
  'order_seconds': 'Segundos',
  'order_give_name': 'Poner un nombre a su número de teléfono',
  'order_wait_for': 'Espere la transacción.',
  'order_check_status': 'Puede comprobar el estado',
  'separated_words_OR': 'o',
  'separated_words_PASSWORD': 'contraseña',
  'share_links_title': '¡Solicite una recarga de amigos o familiares!',
  'share_links_text1': 'Ingrese su número y elija su operador - ',
  'share_links_text2': '¡Luego comparta su enlace con alguien que pueda ayudarlo a pagar!',
  'share_links_text3': 'Puedes compartir un enlace, sin una cuenta.',
  'share_links_button': 'Enviar un enlace',
  'share_links_hotow': '¿Cómo enviar un enlace?',
  'topbar_currency': 'Moneda',
  'phone_form_in': 'en',
  'phone_form_button_small': 'elige país',
  'country_form_providers_list': 'Operadores Móviles',
  'country_form_select_provider': 'Seleccione su proveedor',
  'country_form_need_full_list': 'Lista completa de proveedores',
  'countries_list': 'Países admitidos',
  'provider_form_select_product': 'Seleccionar producto',
  'provider_form_receive': 'Recibe:',
  'provider_form_costs': 'Costos:',
  'receipt_operator': 'Operadora',
  'receipt_phone_number': 'Número de teléfono',
  'receipt_date': 'Fecha',
  'esim_header': 'Planes de datos eSIM',
  'esim_view_all': 'Ver todo',
  'esim_loading': 'Cargando planes eSIM...',
  'esim_empty': 'No hay productos eSIM disponibles',
  'esim_from': 'Desde',
  'wallet_page_title': 'Tu Saldo',
  'wallet_current_balance': 'Saldo Actual',
  'wallet_deposit_now': 'Depositar Ahora',
  'wallet_recent_deposits': 'Depósitos Recientes',
  'wallet_no_deposits': 'Sin historial de depósitos',
  'wallet_deposit_title': 'Depositar al Saldo',
  'wallet_select_amount': 'Seleccionar Monto',
  'wallet_deposit_amount': 'Monto del Depósito',
  'wallet_processing_fee': 'Comisión',
  'wallet_total': 'Total',
  'wallet_saved_cards': 'Tarjetas Guardadas',
  'wallet_deposit_btn': 'Depositar',
  'wallet_or_new_card': 'o pagar con nueva tarjeta',
  'wallet_pay_with_card': 'Pagar con Tarjeta de Crédito',
  'wallet_use_saved_card': 'Usar Tarjeta Guardada',
  // Nav
  'nav_esim_data': 'eSIM Datos',
  'nav_mobile_topup': 'Recarga Móvil',
  'nav_my_orders': 'Mis Pedidos',
  'nav_help': 'Ayuda',
  'nav_user_menu': 'Menú',
  'nav_gifts': 'Regalos, Juegos, Utilidades',
  'nav_login': 'Iniciar sesión',
  'nav_settings': 'Configuración',
  // Payment tab
  'payment_choicebox_balance': 'Saldo',
  // Orders
  'orders_empty': 'Aún no ha realizado ninguna recarga.',
  'orders_verifying': 'Verificando pago...',
  'orders_instructions': 'Instrucciones de recarga:',
  'orders_retrying': 'Reintentando...',
  'orders_processing': 'Procesando...',
  'orders_retry': 'Reintentar',
  'orders_retry_left': 'restantes',
  'orders_refund_to': 'Reembolsar a',
  'orders_retry_available': 'Reintentar',
  'orders_refund_available': 'Reembolso disponible',
  'orders_confirm_refund': '¿Está seguro de que desea solicitar un reembolso para este pedido?',
  // Wallet deposit (Stripe/USDC)
  'wallet_deposit_card': 'Depositar {amount} THB con tarjeta',
  'wallet_deposit_usdc': 'Depositar {amount} THB con USDC',
  'wallet_fee_info': 'Comisión: {fee} THB | Total: {total} THB',
  'wallet_fee_info_crypto': 'Comisión: {fee} THB | Total: {total} THB | Convertido a USD al pagar',
  'wallet_fee_info_crypto_short': 'Comisión: {fee} THB | Convertido a USD al pagar',
  'wallet_crypto_fee': 'Comisión (1.5%)',
  'wallet_deposit_success': 'Depósito exitoso. Saldo actualizado.',
  // Login / Signup
  'login_verification_sent': 'Le enviamos un correo de verificación',
  'login_check_email': 'Revise su correo para verificar su cuenta.',
  'login_resend': 'Reenviar correo de verificación',
  'login_resend_confirmation': 'Reenviar confirmación a',
  'login_already_authed': 'Ya está autenticado',
  'login_go_back': 'Puede volver atrás',
  'login_go_main': 'Ir a la página principal',
  'login_auth_failed': 'Error de autenticación',
  'login_form_verified': 'Este formulario debe ser verificado',
  'login_field_too_short': '{field} es demasiado corto',
  'login_confirmation_resent': 'El correo de confirmación ha sido reenviado.',
  // Signup (topup flow)
  'signup_fb': 'Registrarse con Facebook',
  'signup_or_email': 'O registrarse con correo',
  'signup_fields_required': 'Todos los campos son obligatorios',
  'signup_first_name': 'Nombre',
  'signup_last_name': 'Apellido',
  'signup_email': 'Correo electrónico',
  'signup_password': 'Contraseña',
  'signup_password_placeholder': 'Mín. 6 caracteres',
  'signup_btn': 'Registrarse',
  'signup_have_account': '¿Ya tiene una cuenta? Iniciar sesión.',
  // Profile
  'profile_title': 'Perfil',
  'profile_email': 'Correo:',
  'profile_first_name': 'Nombre:',
  'profile_last_name': 'Apellido:',
  'profile_edit': 'Editar',
  'profile_cancel': 'Cancelar',
  'profile_save': 'Guardar',
  'profile_change_password': 'Cambiar contraseña',
  'profile_new_password': 'Nueva contraseña:',
  'profile_confirm_password': 'Confirmar contraseña:',
  'profile_update': 'Actualizar',
  'profile_delete_account': 'Eliminar cuenta',
  'profile_delete': 'Eliminar',
  'profile_confirm_operation': 'Confirmar operación:',
  'profile_confirm_no': 'No',
  'profile_confirm_yes': 'Sí, quiero eliminar mi cuenta',
  'profile_try_again': 'Intentar de nuevo',
  'profile_trusted': 'De confianza',
  'profile_member_since': 'Miembro desde:',
  'profile_orders': 'Pedidos:',
  'profile_orders_completed': 'completados',
  'profile_referral': 'Referido:',
  'profile_months': 'meses',
  'profile_year': 'año',
  'profile_years': 'años',
  'profile_name_required': 'Nombre y apellido son obligatorios',
  'profile_passwords_required': 'Contraseñas obligatorias',
  'profile_password_too_short': 'La contraseña es demasiado corta',
  'profile_password_mismatch': 'Las contraseñas no coinciden',
  'profile_need_confirmation': 'Se necesita confirmación',
  'profile_not_found': 'Datos del perfil no encontrados',
  'profile_update_failed': 'Error al actualizar, inténtelo más tarde...',
  'profile_operation_failed': 'Error en la operación, inténtelo más tarde...',
  // Contact
  'contact_title': 'Contáctenos',
  'contact_name': 'Nombre',
  'contact_email': 'Correo electrónico',
  'contact_message': 'Mensaje',
  'contact_send': 'Enviar mensaje',
  'contact_fields_required': 'Todos los campos son obligatorios',
  'contact_form_verified': 'Este formulario debe ser verificado',
  'contact_error': '¡Error! Inténtelo más tarde',
  'contact_messenger': 'Facebook Messenger:',
  'contact_send_message': 'Enviar mensaje',
  'contact_email_label': 'Correo:',
  'contact_phone': 'Teléfono:',
  'footer_home': 'Inicio',
  // Footer articles
  'footer_article_dataplans': 'Planes de datos tailandeses',
  'footer_article_ussd': 'Códigos USSD tailandeses',
  'footer_article_validity': 'Extender validez de SIM tailandesa',
  'footer_whatsapp_bot': 'Bot de WhatsApp',

  // Lucky Number page
  'lucky_title': 'Numero de la suerte',
  'lucky_title_bold': 'Consulta',
  'lucky_subtitle': 'Numerologia gratuita y horoscopo para cualquier numero de celular.',
  'lucky_placeholder': 'Ingresa un numero de telefono',
  'lucky_button': 'Leer mi numero',
  'lucky_hint': 'Ingresa al menos 4 digitos para una lectura.',
  'lucky_privacy': 'La lectura se calcula en tu dispositivo. Las tarjetas se generan solo con los digitos — no se almacena nada.',
  'lucky_how_title': 'Como funciona la numerologia del telefono',
  'lucky_how_p1': 'En la tradicion latina, cada <b>digito</b> lleva una identidad planetaria — 1 es el Sol (liderazgo), 3 Jupiter (suerte y abundancia), 7 Neptuno (espiritualidad y misterio), 8 Saturno (poder y dinero). El <b>7</b> es el numero mas afortunado en el mundo hispanohablante — siete dias, siete colores, siete notas musicales. El <b>3</b> trae suerte por la Santisima Trinidad. El <b>13</b> y el <b>martes 13</b> se consideran de mala suerte — "En martes, ni te cases ni te embarques".',
  'lucky_how_p2': 'Las parejas afortunadas incluyen <b>37</b> y <b>73</b> (sabiduria con suerte), <b>15</b> (la quinceanera, celebracion de vida), <b>21</b> (la suerte en el blackjack), y <b>77</b>/<b>88</b> para prosperidad doble. En Mexico, el <b>57</b> es famoso por la loteria. En Espana, el <b>22</b> (El Gordo) es el numero mas buscado en la Loteria de Navidad. Evita el <b>4</b> solo y las combinaciones con <b>13</b>.',
  'lucky_how_p3': 'Ingresa tu numero arriba para obtener tu lectura completa — mas datos curiosos: que deletrea tu numero en el teclado, su codigo Morse, y mas. Es gratis, instantaneo y solo por diversion — y recibes una tarjeta para compartir en WhatsApp, Instagram, Facebook y mas.',
  'lucky_pair_title': 'Par por par',
  'lucky_pair_note': 'Los digitos adyacentes se leen como pares; los pares finales — los que se dicen al final — cuentan doble, mostrados en <b>negrita</b>.',
  'lucky_best_pair': 'Mejor par:',
  'lucky_watch_out': 'Cuidado con',
  'lucky_facts_title': 'Datos curiosos de tu numero',
  'lucky_verse_title': 'El verso de tu numero',
  'lucky_share_title': 'Comparte la tarjeta de tu numero',
  'lucky_share_note': 'Comparte el enlace y se despliega como tarjeta en WhatsApp, Facebook, X — o descarga las imagenes para Instagram. Las tarjetas se generan solo con los digitos.',
  'lucky_share_text': 'Mi numero obtuvo {score}/100 — {tier}. Consulta el tuyo:',
  'lucky_share_native': 'Compartir\u2026',
  'lucky_copied': 'Copiado \u2713',
  'lucky_copy_link': 'Copiar enlace',
  'lucky_disclaimer': 'Solo para entretenimiento. Un buen numero no pagara tus cuentas — pero marcarlo sera mas divertido.',
  'lucky_path_number': 'Numero de camino',
  'lucky_digits_sum': 'los digitos suman',
  'lucky_ruled_by': 'Regido por',
  'lucky_lucky_day': 'Dia de suerte:',
  'lucky_lucky_color': 'Color de suerte:',
  'lucky_sidebar_love_title': 'Te gusta tu numero?',
  'lucky_sidebar_love_text': 'Un numero de la suerte solo funciona mientras este activo. <a href="/recharge">Recargalo</a> en segundos — Tailandia y 140+ paises, sin cuenta necesaria.',
  'lucky_sidebar_travel_title': 'Vas a viajar?',
  'lucky_sidebar_travel_text': 'Conserva tu numero de la suerte para llamadas y consigue un <a href="/dataplans">eSIM de viaje</a> para datos — sin cambiar SIM, sin roaming.',
  'lucky_sidebar_private_title': 'Disenado para la privacidad',
  'lucky_sidebar_private_text': 'La lectura se ejecuta en tu navegador. Las tarjetas se generan solo con los digitos — no almacenamos los numeros que consultas.',

  // eSIM country landing pages (/esim/<country>) — EsimLanding.jsx
  'el_h1': 'Planes de datos eSIM en {c}',
  'el_count': '{n} planes para {c}',
  'el_pick': 'elige un tamaño para ver precios',
  'el_prices_in': 'Precios en',
  'el_all_plans': 'Todos los planes',
  'el_show_all': 'Ver los {n} tamaños',
  'el_show_less': 'Ver menos',
  'el_popular': 'Popular',
  'el_best_value': 'Mejor precio',
  'el_unlimited': 'Ilimitado',
  'el_per_day': '/ día',
  'el_daily_badge': 'Plan diario',
  'el_daily_note': 'los datos se renuevan cada día',
  'el_day': 'día',
  'el_days': 'días',
  'el_country_only': 'solo {c}',
  'el_regional_grp': 'Planes regionales — incluyen {c}',
  'el_global_grp': 'Planes globales — incluyen {c}',
  'el_countries_n': '{n} países',
  'el_qr_instant': 'QR entregado al instante',
  'el_buy': 'Comprar',
  'el_no_plans': 'Aún no hay planes eSIM para {c}.',
  'el_browse_all': 'Ver todos los destinos',
  'el_error': 'No se pudieron cargar los planes.',
  'el_retry': 'Reintentar',
  'el_sub': 'Planes de datos desde {p} — código QR entregado tras el pago. Instálalo antes de volar y conéctate al llegar. Sin SIM física, sin roaming y con reembolso automático si nunca lo usas.',
  'el_trust_qr': 'QR en segundos',
  'el_trust_refund': '¿eSIM sin usar? Reembolso automático',
  'el_trust_support': 'Soporte 24/7',
  'el_step1': 'Elige el tamaño del plan',
  'el_step2': 'Paga — el QR llega al instante',
  'el_step3': 'Escanea para instalar',
  'el_step4': 'Conéctate al llegar',
  'el_proof_orders': 'Pedidos entregados',
  'el_proof_since': 'Desde 2009',
  'el_proof_since_l': '16 años de recargas',
  'el_proof_networks': '{n} redes',
  'el_proof_refund': 'Reembolso automático',
  'el_proof_refund_l': 'Las eSIM sin usar se reembolsan automáticamente',
  'el_refund_h': '¿No la usaste? Reembolso automático.',
  'el_refund_title': 'Los planes cambian — tu dinero vuelve.',
  'el_refund_body': 'Si tu eSIM muestra cero datos usados, el reembolso es automático — sin tickets de soporte ni formularios. Se devuelve a tu método de pago original o a tu saldo de MobileTopup. ¿Instalaste la eSIM pero nunca te conectaste? También está cubierto.',
  'el_details_h': 'Datos eSIM en {c} — los detalles',
  'el_networks_h': 'Redes y cobertura',
  'el_networks_p': 'Los planes eSIM de {c} se conectan a las principales redes móviles locales por 4G/5G. La red exacta de cada plan aparece en sus detalles antes de comprar.',
  'el_activation_h': 'Activación y validez',
  'el_act1': 'Instala cuando quieras — el código QR no caduca al recibirlo. Instálalo en casa antes del viaje.',
  'el_act2': 'La mayoría de los planes empiezan con la primera conexión a una red local, no al comprar — revisa los detalles del plan.',
  'el_act3': 'Solo datos — sin número local. WhatsApp, Viber e iMessage siguen funcionando con tu número de siempre.',
  'el_act4': 'Casi todos los planes permiten compartir internet (hotspot).',
  'el_act5': 'Muchos planes se pueden recargar después — sin nuevo código QR.',
  'el_why_h': '¿Por qué una eSIM y no roaming o una SIM local?',
  'el_why_p': 'El roaming suele costar $5–$10 al día. Una SIM local significa hacer fila en el aeropuerto con tu pasaporte. Una eSIM para {c} evita ambos: compra en línea en dos minutos, conserva tu SIM para llamadas y códigos OTP, y paga los datos a precio local.',
  'el_faq_h': 'Preguntas frecuentes',
  'el_faq1q': '¿Cómo funciona una eSIM de {c}?',
  'el_faq1a': 'Compra un plan, escanea el código QR que te enviamos y los datos funcionan en cuanto llegas — sin cambiar de SIM ni cargos de roaming de tu operador.',
  'el_faq2q': '¿Cuándo empieza el plan?',
  'el_faq2a': 'La mayoría se activa con la primera conexión a una red local, así que puedes instalarla antes de viajar. La validez empieza a contar entonces.',
  'el_faq3q': '¿Mi teléfono es compatible?',
  'el_faq3a': 'La mayoría de los teléfonos desde 2019 admiten eSIM — iPhone XS en adelante, Samsung Galaxy recientes, Google Pixel 3 en adelante. Debe estar liberado. Marca *#06# — si ves un EID, es compatible.',
  'el_faq4q': '¿Y si no uso la eSIM?',
  'el_faq4a': 'Las eSIM con cero datos usados se reembolsan automáticamente — ni siquiera necesitas contactarnos.',
  'el_faq5q': '¿Qué es un plan diario?',
  'el_faq5a': 'Los planes diarios dan una cuota de datos que se renueva cada día. Al agotarla, la velocidad baja hasta el día siguiente — sin corte total.',
  'el_faq6q': '¿Puedo llamar o recibir SMS?',
  'el_faq6a': 'La eSIM es solo de datos, sin número local. Usa WhatsApp, Viber o FaceTime para llamar. Tu SIM de siempre sigue recibiendo SMS — solo desactiva su roaming de datos.',
  'el_faq7q': '¿Puedo recargar o extender mi plan?',
  'el_faq7a': 'Muchos planes admiten recargas — compra más datos para la misma eSIM desde tu página de pedidos, sin nuevo QR ni reinstalación.',
  'el_faq8q': '¿Qué métodos de pago aceptan?',
  'el_faq8a': 'Tarjetas de crédito y débito internacionales (con 3-D Secure), bancos tailandeses, Alipay, USDC y tu saldo de MobileTopup.',
  'el_also_topup': '¿Necesitas saldo móvil? Recarga cualquier número de {c}',
  'el_seo': 'Compara planes de datos eSIM en {c} por tamaño y precio. MobileTopup.com entrega el código QR al instante tras el pago — instala en minutos, conéctate al llegar y recarga la misma eSIM después si necesitas más datos. Precios claros sin cargos ocultos, y toda eSIM con cero datos usados se reembolsa automáticamente. En el negocio desde 2009, con más de un millón de pedidos entregados.',

  'tmu_page_title': 'Recárgame',
  'tmu_page_sub': 'Pide a amigos o familiares que añadan saldo móvil a tu cuenta',
  'tmu_how_it_works': 'Cómo funciona',
  'tmu_how_it_works_body': 'Comparte tu enlace por SMS, WhatsApp o correo electrónico. Cualquiera puede pagarlo — sin necesidad de cuenta — y el dinero llega directo a tu saldo, listo para usar en minutos, datos o tarjetas de regalo.',
  'tmu_link_created': 'Enlace creado:',
  'tmu_your_profile': 'Tu perfil',
  'tmu_profile_sub': 'Se muestra a quien le pidas ayuda, para que sepan que eres tú de verdad.',
  'tmu_photo_uploading': 'Subiendo…',
  'tmu_photo_set': 'Se muestra a quien le pidas ayuda.',
  'tmu_photo_required': 'Obligatorio — añade una foto real tuya para que quien envíe el dinero sepa que eres tú de verdad.',
  'tmu_remove_photo': 'Quitar foto',
  'tmu_new_request': 'Nueva solicitud',
  'tmu_your_name': 'Tu nombre',
  'tmu_your_phone': 'Tu número de teléfono',
  'tmu_phone_hint': 'Este es el número que recibirá la recarga, y se muestra a quien envía el dinero para confirmar que la solicitud es real.',
  'tmu_amount_label': 'Monto',
  'tmu_amount_fixed': 'Monto fijo',
  'tmu_amount_open': 'Que elija el remitente',
  'tmu_requested_amount': 'Monto solicitado (฿)',
  'tmu_min_amount': 'Mínimo (฿)',
  'tmu_max_amount': 'Máximo (฿)',
  'tmu_note_label': 'Nota para el remitente',
  'tmu_note_placeholder': 'ej. Por favor ayúdame a recargar mi teléfono',
  'tmu_note_required_hint': 'Una nota personal genera confianza — es obligatoria.',
  'tmu_cap_hint': 'Hasta {cap} en total por día entre todos tus enlaces. El remitente cubre la comisión — tú siempre recibes el monto completo.',
  'tmu_photo_required_notice': 'Añade una foto arriba antes de crear una solicitud.',
  'tmu_creating': 'Creando…',
  'tmu_create_link': 'Crear enlace',
  'tmu_your_links': 'Tus enlaces ({count} activos)',
  'tmu_links_error': 'No se pudieron cargar tus enlaces. Actualiza para intentarlo de nuevo.',
  'tmu_links_empty': 'Aún no tienes enlaces de Recárgame — crea el primero arriba.',
  'tmu_amount_fixed_suffix': 'fijo',
  'tmu_amount_open_suffix': '(abierto)',
  'tmu_received': 'Recibido:',
  'tmu_of_cap_per_day': 'de {cap}/día',
  'tmu_copy_link': 'Copiar enlace',
  'tmu_copied': 'Copiado',
  'tmu_share': 'Compartir',
  'tmu_active': 'Activo',
  'tmu_cancelled': 'Cancelado',
  'tmu_cancel_confirm': '¿Cancelar este enlace de Recárgame? Quienes ya lo tengan no podrán pagarlo.',
  'tmu_no_payments': 'Aún no hay pagos.',
  'tmu_anonymous': 'Anónimo',
  'tmu_share_in': 'Compartir en',
  'tmu_send_title': 'Enviar saldo móvil',
  'tmu_loading': 'Cargando…',
  'tmu_not_found': 'No se encontró este enlace.',
  'tmu_inactive': 'Este enlace ya no está activo.',
  'tmu_checking_payment': 'Verificando el estado del pago…',
  'tmu_payment_success': '¡Pago enviado — gracias! Se notificará a {name} de inmediato.',
  'tmu_payment_failed': 'El pago no se completó. No se realizó ningún cargo.',
  'tmu_payment_timeout': 'Aún procesando — puede tardar un minuto. No es necesario pagar de nuevo.',
  'tmu_asking_help': '{name} te está pidiendo ayuda',
  'tmu_help_body': 'Ayuda a {firstName} a tener minutos y datos para seguir en contacto contigo. Lo agradecerá mucho.',
  'tmu_note_says': '{name} dice',
  'tmu_recipient_thailand': 'Destinatario · Tailandia',
  'tmu_choose_amount': 'Elige un monto para enviar',
  'tmu_amount_to': 'Monto para {firstName}',
  'tmu_processing_fee': 'Comisión de procesamiento (a tu cargo)',
  'tmu_total_pay': 'Total a pagar',
  'tmu_payment_method': 'Método de pago',
  'tmu_card_label': 'Tarjeta de crédito / débito',
  'tmu_card_sub': 'Visa, Mastercard, JCB — lo más fácil desde el extranjero',
  'tmu_thai_label': 'Pagos tailandeses',
  'tmu_thai_sub': 'Apps bancarias y billeteras tailandesas',
  'tmu_your_email': 'Tu correo electrónico',
  'tmu_email_hint': 'Para tu recibo — no necesitas crear una cuenta.',
  'tmu_email_invalid': 'Ingresa un correo electrónico válido para tu recibo.',
  'tmu_starting_payment': 'Iniciando el pago…',
  'tmu_send_amount': 'Enviar {amount}',
  'tmu_trust': 'Protegido por Omise · mobiletopup.com nunca almacena los datos de tu tarjeta.',
  'tmu_view_payments': 'Ver pagos',
  'tmu_cancel_link': 'Cancelar enlace',
  'tmu_phone_placeholder': '08X XXX XXXX o +63 917 123 4567',
  'tmu_phone_examples': 'Número tailandés (08X XXX XXXX) o internacional con código de país, p. ej. +63 917 123 4567.',
  'tmu_global_off': 'Los números internacionales aún no están disponibles — usa un móvil tailandés.',
  'tmu_requests_in_thb': 'Solicitudes en THB · {range}',
  'tmu_requests_in_usd': 'Solicitudes en USD · {range}',
  'tmu_requested_amount_usd': 'Importe solicitado ($ USD)',
  'tmu_min_amount_usd': 'Mínimo ($)',
  'tmu_max_amount_usd': 'Máximo ($)',
  'tmu_cap_hint_usd': 'Cada solicitud puede ser de {range}. Quien envía paga la comisión de procesamiento y la conversión de divisa — tú siempre recibes el importe completo en USD.',
  'tmu_verify_cta': 'Verificar este número por SMS (opcional)',
  'tmu_verify_why': 'La insignia «Verificado» muestra a quien envía que el número es realmente tuyo.',
  'tmu_verify_sending': 'Enviando…',
  'tmu_verify_code_sent': 'Código enviado. Introduce el código de 6 dígitos del SMS.',
  'tmu_verify_code_label': 'Código de 6 dígitos',
  'tmu_verify_confirm': 'Verificar',
  'tmu_verify_checking': 'Comprobando…',
  'tmu_verify_resend': 'Reenviar código',
  'tmu_verify_send_failed': 'No se pudo enviar el código. Revisa el número e inténtalo de nuevo.',
  'tmu_verify_failed': 'Ese código no funcionó. Revísalo e inténtalo de nuevo.',
  'tmu_verify_too_many': 'Demasiados intentos. Espera unos minutos e inténtalo de nuevo.',
  'tmu_verified': 'Verificado',
  'tmu_not_verified': 'Sin verificar',
  'tmu_verified_number': 'Número verificado',
  'tmu_top_up_number': 'Recargar este número',
  'tmu_recipient_in': 'Destinatario · {country}',
  'tmu_receives': '{firstName} recibe',
  'tmu_total_usd': 'Total (USD)',
  'tmu_charged_thb': 'Se te cobrarán {amount} (≈ {rate} THB por USD)',
  'tmu_pay_amount': 'Pagar {amount}'
}
